import React, { ReactText } from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';

import { Icon, IIconProps } from './Icon';
import { BaseText } from './BaseText';
import { ColorType } from '@types';

const BadgePositionContainer = styled(View)({
  position: 'absolute',
  top: -7,
  right: -5,
});

interface IBadgeContainerStyleProps {
  color: ColorType;
  size: number;
}

const BadgeContainer = styled(View)(
  (props: IBadgeContainerStyleProps) => ({
    px: '$1',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: props.size,
    height: props.size,
    borderRadius: props.size / 2,
    bg: props.color,
    overflow: 'hidden',
  }),
);

const Text = styled(BaseText)({
  variant: 'text.xsmall',
  color: '$background0',
});

interface IIconWithBadgeProps extends IIconProps {
  text: ReactText;
  badgeColor?: ColorType;
}

export function IconWithBadge({
  size = 20,
  text,
  badgeColor = '$error300',
  ...props
}: IIconWithBadgeProps) {
  return (
    <View>
      <Icon size={size} {...props} />

      <BadgePositionContainer>
        <BadgeContainer size={size * 0.8} color={badgeColor}>
          <Text>{text}</Text>
        </BadgeContainer>
      </BadgePositionContainer>
    </View>
  );
}
